/**
 * 입력 필드의 플레이스홀더 생성 유틸리티
 */

interface PlaceholderConfig {
  required: boolean;
  baseMessage?: string;
}

/**
 * 필수/선택 여부에 따른 플레이스홀더 텍스트 생성
 * @param config 플레이스홀더 설정
 * @returns 생성된 플레이스홀더 텍스트
 */
export const generateInputPlaceholder = ({ required, baseMessage = '입력해 주세요' }: PlaceholderConfig): string => {
  const prefix = required ? '[필수]' : '[선택]';
  return `${prefix} ${baseMessage}`;
};
